import {
  Affiliation,
  AssetStatus,
  Member,
  MemberAsset,
  HdcProduct,
  ProductType,
  VehicleType,
} from "../../../types/Member.types";
import { getFormattedDate } from "../../utils/getFormattedDate";

type HdcBenefit = {
  distance: number;
  coverage: VehicleType;
};

const benefits: Map<string, HdcBenefit> = new Map<string, HdcBenefit>([
  // 1.0
  ["USMEMB2", { distance: 100, coverage: VehicleType.CLASSIC }],
  ["USMEMBVIP", { distance: 150, coverage: VehicleType.ALLVEHICLES }],
  ["CANMEMB2", { distance: 80, coverage: VehicleType.CLASSIC }],
  ["CANMEMBVIP", { distance: 200, coverage: VehicleType.ALLVEHICLES }],
  // 1.5
  ["USMEMBHDC2", { distance: 100, coverage: VehicleType.CLASSIC }],
  ["USMEMBHDCVIP", { distance: 150, coverage: VehicleType.ALLVEHICLES }],
  ["CANMEMBHDC2", { distance: 80, coverage: VehicleType.CLASSIC }],
  ["CANMEMBHDCVIP", { distance: 200, coverage: VehicleType.ALLVEHICLES }],
]);

export const createNonPaidMember = (member?: Partial<Member>): Member => ({
  __typename: member?.__typename ?? "CustomerMember",
  id: member?.id ?? "HDC00208785",
  firstName: member?.firstName ?? "Andrew",
  lastName: member?.lastName ?? "Hill",
  email: member?.email ?? "stephenhall@sfdc.co.0011i00000jrj3iqad",
  assets: [],
  identity: member?.identity ?? {
    federationId: "d2762af1-cd7d-421a-939c-0499eaffe401",
  },
  salesForceAccount: member?.salesForceAccount ?? {
    id: "106064688",
    accountNumber: "105620669",
  },
});

export const createPaidMember = (member?: Partial<Member>): Member => ({
  __typename: member?.__typename ?? "CustomerMember",
  id: member?.id ?? "HDC00208785",
  firstName: member?.firstName ?? "Andrew",
  lastName: member?.lastName ?? "Hill",
  email: member?.email ?? "stephenhall@sfdc.co.0011i00000jrj3iqad",
  assets: [buildAsset(member?.assets?.at(0))],
  identity: member?.identity ?? {
    federationId: "d2762af1-cd7d-421a-939c-0499eaffe401",
  },
  salesForceAccount: member?.salesForceAccount ?? {
    id: "106064688",
    accountNumber: "105620669",
  },
});

const buildAsset = (asset?: Partial<MemberAsset>): Partial<MemberAsset> => ({
  id: asset?.id ?? "02i8W000007oV9jQAE",
  status: asset?.status ?? AssetStatus.ACTIVE,
  affiliation: asset?.affiliation ?? Affiliation.HAGERTY,
  amountPaid: asset?.amountPaid ?? {
    amount: 70,
  },
  activatedDate: asset?.activatedDate ?? getFormattedDate({ months: -8 }),
  effectiveAt: asset?.effectiveAt ?? getFormattedDate({ months: -8 }),
  expireAt:
    asset?.expireAt ?? asset?.product?.isVIP
      ? null
      : getFormattedDate({ months: 4 }),
  omniOrderId: asset?.omniOrderId,
  product: buildProduct(asset?.product),
});

const buildProduct = (product?: Partial<HdcProduct>): Partial<HdcProduct> => ({
  id: product?.id ?? "01t1I000003ATAFQA4",
  type: product?.type ?? ProductType.MEMBERSHIP,
  code: product?.code ?? "USMEMB2",
  price: product?.price ?? {
    amount: 70,
  },
  isVIP: product?.isVIP ?? false,
  level: product?.level ?? 2,
  benefits: product?.benefits ?? [
    {
      __typename: "CustomerMemberRoadsideBenefit",
      included: true,
      towingDistance: benefits.get(product?.code ?? "USMEMB2")?.distance,
      amountCovered: benefits.get(product?.code ?? "USMEMB2")?.distance,
      vehicleType: benefits.get(product?.code ?? "USMEMB2")?.coverage,
    },
    {
      __typename: "CustomerMemberMagazineBenefit",
      included: true,
      issues: 6,
    },
    {
      __typename: "CustomerMemberHvtBenefit",
      included: true,
    },
    {
      __typename: "CustomerMemberEventsBenefit",
      included: true,
    },
  ],
});
